import React, { useCallback } from 'react';
import classNames from 'classnames';
import styles from './FullStatsSwitch.module.scss';

const FullStatsSwitch = ({ checked, onChange, label }) => {
  const handleChange = useCallback(
    event => {
      onChange(event.target.checked);
    },
    [onChange],
  );

  return (
    // <label> envolvente: clic en label O en el track/thumb dispara el input.
    // El <input type="checkbox" role="switch"> maneja teclado (Space) y a11y.
    <label className={styles['full-stats-switch']}>
      {label && (
        <span className={styles['full-stats-switch__label']}>{label}</span>
      )}
      <input
        type="checkbox"
        role="switch"
        aria-checked={checked}
        checked={checked}
        onChange={handleChange}
        className={styles['full-stats-switch__input']}
      />
      <span
        aria-hidden
        className={classNames(styles['full-stats-switch__track'], {
          [styles['full-stats-switch__track--on']]: checked,
        })}
      >
        <span
          className={classNames(styles['full-stats-switch__thumb'], {
            [styles['full-stats-switch__thumb--on']]: checked,
          })}
        />
      </span>
    </label>
  );
};

export default FullStatsSwitch;
